export default __webpack_public_path__ + "static/media/gallery_05.3ec611c6.jpg";